import { render, staticRenderFns } from "./PreviewForm1.vue?vue&type=template&id=656a9fa7"
import script from "./PreviewForm1.vue?vue&type=script&lang=ts"
export * from "./PreviewForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports